import {parse as parseOverrideOmitPhoneNumberValue} from './overrideOmitPhoneNumberValue';

export const parsers = {
  'override-omit-phone-number': parseOverrideOmitPhoneNumberValue,
} as const;
